<ng-scrollbar [style.height]="customStyle" visibility="hover" [dir]="direction">
  <ng-content />
</ng-scrollbar>
